'use client'

import { useTranslation } from 'react-i18next'
import { Link } from '@tanstack/react-router'
import { Button, Flex, Heading, Text, VStack } from '@chakra-ui/react'
import { Home, Users } from 'lucide-react'
import { AppCard } from '@/shared/ui'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <Flex
      align="center"
      justify="center"
      minH="min(70vh, 560px)"
      p={{ base: 4, md: 8 }}
      bg="bg"
    >
      <AppCard.Root maxW="440px" w="full">
        <AppCard.Body p={{ base: 6, md: 8 }}>
          <VStack gap={5} align="stretch" textAlign="center">
            <Text
              fontSize="4xl"
              fontWeight="bold"
              lineHeight={1}
              color="primary.fg"
              letterSpacing="-0.02em"
            >
              {t('not_found.code')}
            </Text>
            <Heading size="lg" fontWeight="bold" color="fg">
              {t('not_found.title')}
            </Heading>
            <Text fontSize="sm" color="fg.muted" lineHeight={1.6}>
              {t('not_found.description')}
            </Text>
            <Flex
              gap={3}
              flexDir={{ base: 'column', sm: 'row' }}
              justify="center"
              pt={2}
            >
              <Link to="/" style={{ textDecoration: 'none', flex: 1 }}>
                <Button
                  w="full"
                  gap={2}
                  variant="outline"
                  borderRadius="md"
                  borderColor="border"
                  color="fg"
                  _hover={{ bg: 'bg.subtle' }}
                >
                  <Home size={16} />
                  {t('not_found.home')}
                </Button>
              </Link>
              <Link to="/donors" style={{ textDecoration: 'none', flex: 1 }}>
                <Button
                  w="full"
                  gap={2}
                  bg="primary.solid"
                  color="white"
                  borderRadius="md"
                  _hover={{ opacity: 0.85 }}
                  _active={{ opacity: 0.7 }}
                >
                  <Users size={16} />
                  {t('not_found.donors')}
                </Button>
              </Link>
            </Flex>
          </VStack>
        </AppCard.Body>
      </AppCard.Root>
    </Flex>
  )
}
